/* eslint-disable no-script-url */
import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Link } from "react-router-dom";
import "./icon-button.scss";

const IconButton = ({
  href,
  to,
  onClick,
  icon,
  size,
  newWindow,
  className,
  text,
  forwardedRef,
  ...props
}) => {
  const renderInner = () => (
    <>
      <span className="icon-button__text">{text}</span>
      {icon}
    </>
  );

  const classes = classNames("icon-button", `icon-button--${size}`, className);

  if (onClick) {
    return (
      <button type="button" className={classes} onClick={onClick} ref={forwardedRef} {...props}>
        {renderInner()}
      </button>
    );
  }

  if (to) {
    return (
      <Link to={to} className={classes} innerRef={forwardedRef} {...props}>
        {renderInner()}
      </Link>
    );
  }

  const targetProps = newWindow
    ? {
        target: "_blank",
        rel: "noopener noreferrer",
      }
    : {};
  return (
    <a href={href} className={classes} ref={forwardedRef} {...targetProps} {...props}>
      {renderInner()}
    </a>
  );
};

IconButton.propTypes = {
  icon: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  to: PropTypes.string,
  href: PropTypes.string,
  onClick: PropTypes.func,
  size: PropTypes.oneOf(["small", "medium", "large"]),
  newWindow: PropTypes.bool,
  className: PropTypes.string,
  forwardedRef: PropTypes.oneOfType([
    PropTypes.shape({ current: PropTypes.instanceOf(<button />) }),
    PropTypes.func,
  ]),
};

IconButton.defaultProps = {
  href: "#",
  size: "medium",
};

export default IconButton;
